<template>
  <v-autocomplete multiple clearable label="店铺列表" class="store-selector"
                  v-model="selectedStores" :items="stores"></v-autocomplete>
</template>

<script>
export default {
  name: "StoreSelector",
  model: {
    prop: "selected",
    event: "update"
  },
  props: {
    selected: []
  },
  computed: {
    selectedStores: {
      get() {
        return this.selected
      },
      set(val) {
        this.$emit("update", val)
        localStorage.setItem("selectedStores", JSON.stringify(val));
      }
    }
  },
  data() {
    return {
      loading: true,
      stores: []
    }
  },
  methods: {
    getData() {
      this.$axios.get("/store/own", {
        params: {
          market: localStorage.getItem("selectedTimer")
        },
        paramsSerializer: params => {
          return this.$qs.stringify(params, {indices: false})
        }
      }).then(response => {
        this.stores = response.data;
      });
    },
    init() {
      if (localStorage.getItem("selectedStores")) {
        let selectedStores;
        try {
          selectedStores = JSON.parse(localStorage.getItem("selectedStores"));
        } catch {
          selectedStores = [];
          localStorage.setItem("selectedStores", JSON.stringify(selectedStores));
        }

        this.selectedStores = selectedStores;
      }
    }
  },
  mounted() {
    this.getData();
    this.init();
  }
}
</script>

<style scoped>
</style>